import type { EntityWithObjectType } from './object_type';

export const groupByObjectType = <
  T extends string,
  Item extends EntityWithObjectType,
>(
  allowedObjectTypes: Readonly<T[]>,
  items: Item[],
): Map<T, Item[]> => {
  const result = new Map<T, Item[]>();

  items.forEach((item) => {
    const objectType = allowedObjectTypes.find(
      (allowed) => allowed === item.object_type,
    );
    if (objectType === undefined) {
      return;
    }
    const objectTypeItems: Item[] = result.get(objectType) ?? [];
    objectTypeItems.push(item);
    result.set(objectType, objectTypeItems);
  });

  return result;
};
